import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getCustomer, updateCustomer } from '@/apis/customers'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { GetCustomerRequest } from '@/types/apis/customers/GetCustomerRequest'
import { GetCustomerResponse } from '@/types/apis/customers/GetCustomerResponse'
import { UpdateCustomerRequest } from '@/types/apis/customers/UpdateCustomerRequest'
import { UpdateCustomerResponse } from '@/types/apis/customers/UpdateCustomerResponse'

export const useUpdateCustomers = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateCustomerResponse>()

  const update = useCallback(
    async (request: UpdateCustomerRequest) => {
      try {
        setLoading(true)
        const res = await updateCustomer(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
        navigate(routes.laundry.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.success') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    updateCustomer: update,
    response,
  }
}

export const useGetCustomer = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetCustomerResponse>()

  const get = useCallback(async (request: GetCustomerRequest) => {
    try {
      setLoading(true)
      const res = await getCustomer(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getCustomer: get,
    response,
  }
}
